import styled from 'styled-components';
import { settingsControlStyles } from './controlStyles';

export const SettingsWorkspaceStyle = styled.div`
  ${settingsControlStyles}
  --settings-accent: #7950f2;
  --settings-text: #283141;
  --settings-muted: #626e7f;
  --settings-border: #e4e8ef;
  --settings-soft: #f4f1fc;
  --settings-surface: #ffffff;
  color: var(--settings-text);
  width: 100%;
  min-width: 0;
  .ant-tabs-card > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
    padding: 24px;
  }
  .ant-form-vertical .ant-form-item {
    margin-bottom: 24px;
    padding-bottom: 0;
  }
  .ant-input-number-group-wrapper {
    width: 100%;
  }
  .settings-tab-label {
    display: inline-flex;
    align-items: center;
    gap: 7px;
  }
  .settings-unsaved {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #b27516;
  }
  .settings-muted {
    color: var(--settings-muted);
    font-size: 13px;
  }
  .settings-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 20px;
    margin-bottom: 24px;
  }
  .settings-panel-header h2 {
    font-size: 16px;
    margin: 0 0 8px;
    font-weight: 600;
  }
  .settings-panel-header p {
    margin: 0;
    color: var(--settings-muted);
    font-size: 13px;
    line-height: 1.6;
  }
  .settings-inline-alert {
    margin-bottom: 20px;
  }
  .settings-stack {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  .settings-two-columns {
    display: grid;
    grid-template-columns: minmax(0, 1.4fr) minmax(300px, 1fr);
    gap: 24px;
    align-items: start;
  }
  .settings-form-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0 24px;
  }
  .settings-form-grid .full-width {
    grid-column: 1 / -1;
  }
  .settings-form-grid .ant-select,
  .settings-form-grid .ant-input-number {
    width: 100%;
  }
  .settings-label {
    font-size: 13px;
    font-weight: 600;
  }
  @media (max-width: 1180px) {
    .settings-two-columns {
      grid-template-columns: minmax(0, 1fr);
    }
  }
  @media (max-width: 680px) {
    .ant-tabs-card > .ant-tabs-content-holder > .ant-tabs-content > .ant-tabs-tabpane {
      padding: 16px;
    }
    .settings-panel-header {
      flex-wrap: wrap;
    }
    .settings-form-grid {
      grid-template-columns: 1fr;
    }
  }
`;

export const SettingsSectionStyle = styled.section`
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 4px;
  min-width: 0;
  overflow: hidden;
  > header {
    padding: 18px 24px;
    border-bottom: 1px solid #edf0f4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }
  > header h3 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
  }
  > header p {
    margin: 6px 0 0;
    color: #626e7f;
    font-size: 12px;
    line-height: 1.6;
  }
  > .settings-section-body {
    padding: 24px;
  }
`;

export const SettingsSaveBarStyle = styled.footer`
  position: sticky;
  bottom: 0;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 20px 0;
  margin-top: 28px;
  background: #fff;
  border-top: 1px solid #e7eaec;
  .save-state {
    color: #626e7f;
    font-size: 13px;
  }
  .save-state.is-dirty {
    color: #996013;
  }
  .save-actions {
    display: flex;
    gap: 12px;
  }
`;

export const SettingChangesStyle = styled.div`
  .change-row {
    padding: 14px 0;
    border-bottom: 1px solid #edf0f4;
  }
  .change-label {
    font-weight: 600;
    margin-bottom: 7px;
  }
  .change-values {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 20px minmax(0, 1fr);
    gap: 12px;
  }
  .change-values > div {
    white-space: pre-line;
    overflow-wrap: anywhere;
    background: #f6f7fa;
    padding: 10px 12px;
    border-radius: 6px;
  }
  .change-values small {
    display: block;
    color: #667386;
    margin-bottom: 4px;
  }
  .change-arrow {
    align-self: center;
    color: #667386;
  }
`;
